'use client';

import { useEffect } from 'react';
import { useThemeStore } from '@/core/stores/theme.store';

// ---------------------------------------------------------------------------
// ThemeApplier
// ---------------------------------------------------------------------------
// Client component that synchronises the Zustand theme store with the
// `data-theme` attribute on <html>. Renders nothing — pure side-effect.
// ---------------------------------------------------------------------------
export function ThemeApplier() {
  const theme = useThemeStore((s) => s.theme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return null;
}
